import { Component } from '@angular/core';
import { Platform, NavController } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { AuthService } from '../../app/shared/services/auth.service';

@Component({
  selector: 'page-mot-de-passe-oublie',
  templateUrl: 'mot-de-passe-oublie.html'
})
export class MotDePasseOublieComponent {
    private auth: any = {
        _username: '',
        _password: '',
        _souvenir: true
    };
    loader: boolean = false;
    
    constructor(
        private platform: Platform,
        private ga: GoogleAnalytics,
        private navCtrl: NavController,
        private authService: AuthService
    ) {
        this.platform.ready().then(_ => {
            this.ga.trackView("Mot de passe oublié");
        });
    }
    
    mdpOublie(): any {
        this.loader = true;
        this.authService.mdpOublie(this.auth).subscribe(_ => {
            this.navCtrl.pop();
        }, (error: any) => {
            console.error(error);
            this.loader = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/mot-de-passe-oublie/mot-de-passe-oublie.ts